<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          header="Service Request Create Subcategory"
        >
          <b-row>
            <b-col md="4">
              <span>Category</span>
            </b-col>
            <b-col md="8">
              <c-input inputType="text" lableText="Category" v-model="name" />
            </b-col>
          </b-row>
          <b-row v-if="userRole === 'Tenant' || userRole === 'Partner'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="scope"
                :options="scope1Options"
                label="label"
                placeholder="Select scope"
              ></eb-select>
            </b-col>
          </b-row>
          <b-row v-if="userRole === 'Admin'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="scope"
                :options="scopeOptions"
                label="label"
                placeholder="Select scope"
              ></eb-select>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <span>Description</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-textarea
                  v-model="description"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Severity</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="severity"
                :options="severityOptions"
                label="label"
                placeholder="Select Severity"
              ></eb-select>
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <b-col md="12">
            <div class="text-center mb-3">
              <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="(e) => $emit('subcategory', e)"
              ></eb-button>

              <eb-button
                class="btn"
                classic="mr-1 btn-primary"
                text="Save"
                @click.prevent="handleSubmit"
              ></eb-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";

export default {
  name: "subcategory",
  components: {
    ebButton,
    cInput,
    ebSelect,
    servicerequestdetails,
  },
  data() {
    return {
      show: true,

      scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
      scopeOptions: ["TENANT"],
      severityOptions: ["Low", "Medium", "High", "Critical"],
      name: "",
      scope: "",
      description: "",
      severity: "",
    };
  },
  props: {
    item: {
      type: String,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    handleSubmit() {
      let dataObj;
      dataObj = {
        parent: this.item,
        scope: this.scope,
        name: this.name,
        description: this.description,
        severity: this.severity,
      };
      this.$store
        .dispatch("servicerequest/createSubcategory", dataObj)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Category added successfully!!",
            type: "success",
          });
          this.$emit("subcategory", {});
          this.$store.dispatch(
            "servicerequest/fetchsubcategoryList",
            this.item
          );
        });
    },
  },
  async mounted() {
    console.log("id", this.item);
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
